import { FaArrowUp, FaClock, FaGraduationCap, FaMoneyBillAlt, FaSeedling, FaUsers } from 'react-icons/fa';
import { images } from '../constants'; 

const careerIntro = {
    sub: "Join Our Team",
    heading: "Join the Landscaping Team Today",
    description: "At Landscaping Services, we're looking for dedicated individuals to become part of our team. Explore exciting career opportunities in gardening, landscaping, and horticulture. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        'Opportunities in Gardening',
        'Assist in Landscaping Operations',
        'Advanced Horticulture Training Programs',
        'Landscaping Situation Management',
        'Support in Garden Safety Measures'
    ],
}

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Gardener',
        details: {
            location: 'GreenScape Landscaping, Springfield',
            timing: 'Full Time',
            hours: 'Shifts, 24/7 Coverage',
            experience: 'Minimum 2 Years in Gardening and Landscaping',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: '987-654-3210',
        },
        overviews: [
            'Join the GreenScape Landscaping team as a skilled Gardener! Your role will involve maintaining and enhancing gardens, parks, and outdoor spaces. With a passion for nature and a commitment to high-quality craftsmanship, this is your opportunity to create stunning landscapes that bring joy and beauty to the community.',
        ],
        responsibilities: [
            'Maintain and nurture plants, flowers, and trees in various outdoor spaces.',
            'Design and implement garden layouts with creative landscaping techniques.',
            'Monitor and improve soil quality to promote healthy plant growth.',
            'Operate and maintain gardening tools and equipment effectively.',
            'Ensure cleanliness and organization in all work areas and projects.',
        ],
        qualifications: [
            'Proven experience in gardening and landscaping for at least 2 years.',
            'Familiarity with various plants, flowers, and landscaping techniques.',
            'Ability to work outdoors in various weather conditions.',
            'Strong attention to detail and commitment to delivering quality results.',
            'Good communication and teamwork skills to collaborate with clients and team members.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Landscaper',
        details: {
            location: 'GreenScape Landscaping, Springfield',
            timing: 'Full Time',
            hours: 'Flexible Shifts, Outdoor Work',
            experience: 'Minimum 2 Years in Landscaping',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: '987-654-3210',
        },
        overviews: [
            'Join the GreenScape Landscaping team as a professional Landscaper! In this role, you’ll transform outdoor spaces into stunning landscapes. If you have a passion for nature, an eye for detail, and experience in creating beautiful, functional designs, we’d love to have you on board.',
        ],
        responsibilities: [
            'Plan and execute landscaping designs for residential and commercial properties.',
            'Plant and maintain flowers, shrubs, and trees to enhance outdoor aesthetics.',
            'Install and maintain hardscape features such as walkways, patios, and retaining walls.',
            'Operate and maintain landscaping tools, machinery, and equipment.',
            'Ensure high-quality work while adhering to safety standards and project timelines.',
        ],
        qualifications: [
            'Proven experience in landscaping or a related field for at least 2 years.',
            'Strong knowledge of plants, hardscape materials, and landscape design principles.',
            'Physical stamina to perform outdoor tasks in various weather conditions.',
            'Excellent attention to detail and ability to deliver visually appealing results.',
            'Good communication skills and ability to collaborate with team members and clients.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Horticulturist',
        details: {
            location: 'GreenThumb Horticulture, Springfield',
            timing: 'Full Time',
            hours: 'Flexible Hours, On-Site Work',
            experience: 'Minimum 3 Years in Horticulture or Related Field',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday, Some Weekends as Needed',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: '555-123-4567',
        },
        overviews: [
            'We are seeking a skilled and passionate Horticulturist to join our GreenThumb team. As a Horticulturist, you will be responsible for cultivating and maintaining plants, designing landscapes, and ensuring the health of all greenery. If you have a deep knowledge of plant care and a love for nature, this is the perfect opportunity for you.',
        ],
        responsibilities: [
            'Cultivate and maintain a wide variety of plants, shrubs, and trees.',
            'Monitor plant health and apply pest control methods when needed.',
            'Design and implement innovative landscaping and planting plans.',
            'Supervise the preparation and fertilization of soil for optimal growth.',
            'Collaborate with clients and team members to deliver exceptional results.',
        ],
        qualifications: [
            'Degree in Horticulture, Botany, or a related field is preferred.',
            'At least 3 years of experience in horticulture or landscape management.',
            'Strong knowledge of plant care, soil preparation, and pest management.',
            'Ability to work outdoors in various weather conditions.',
            'Excellent organizational and teamwork skills with attention to detail.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Landscape Designer',
        details: {
            location: 'GreenVision Designs, Springfield',
            timing: 'Full Time',
            hours: 'Flexible Hours, Project-Based Work',
            experience: 'Minimum 3 Years in Landscape Design or Architecture',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday, Some Weekends for Client Meetings',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: '555-987-6543',
        },
        overviews: [
            'We are looking for a creative and skilled Landscape Designer to join our GreenVision team. As a Landscape Designer, you will be responsible for planning and designing aesthetically pleasing and functional outdoor spaces. This role offers an exciting opportunity to bring your artistic vision to life while collaborating with clients to create breathtaking landscapes.',
        ],
        responsibilities: [
            'Create innovative and sustainable landscape designs for residential and commercial projects.',
            'Collaborate with clients to understand their vision and preferences.',
            'Prepare detailed plans, drawings, and 3D models using design software.',
            'Oversee project implementation to ensure designs are executed accurately.',
            'Stay updated on landscape design trends and environmental practices.',
        ],
        qualifications: [
            'Degree in Landscape Architecture, Design, or a related field.',
            'At least 3 years of professional experience in landscape design.',
            'Proficiency in design tools like AutoCAD, SketchUp, and Adobe Creative Suite.',
            'Strong understanding of plants, materials, and environmental considerations.',
            'Excellent communication, creativity, and project management skills.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Garden Technician',
        details: {
            location: 'Flourish Gardens, Greenville',
            timing: 'Full Time',
            hours: '8:00 AM - 4:00 PM, Monday to Saturday',
            experience: 'Minimum 2 Years in Garden Maintenance and Equipment Handling',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: '555-321-4567',
        },
        overviews: [
            'We are seeking a detail-oriented Garden Technician to join our team at Flourish Gardens. As a Garden Technician, you will be responsible for maintaining the health and beauty of various gardens and outdoor spaces. This is a great opportunity for those passionate about horticulture and skilled in operating gardening equipment.',
        ],
        responsibilities: [
            'Perform routine maintenance tasks, including weeding, pruning, and fertilizing.',
            'Monitor plant health and address pest or disease issues.',
            'Operate and maintain garden tools and equipment effectively.',
            'Install and maintain irrigation systems for optimal water distribution.',
            'Assist in planting and garden layout as per client or designer plans.',
        ],
        qualifications: [
            'High school diploma or equivalent; certification in horticulture is a plus.',
            'At least 2 years of experience in garden maintenance.',
            'Familiarity with gardening tools, irrigation systems, and plant care techniques.',
            'Ability to work outdoors in various weather conditions.',
            'Strong attention to detail and a proactive approach to problem-solving.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Landscape Architect',
        details: {
            location: 'GreenScape Designs, Metropolis',
            timing: 'Full Time',
            hours: '9:00 AM - 5:00 PM, Monday to Friday',
            experience: 'Minimum 3 Years in Landscape Architecture or Related Field',
            position: 'Single Position Available',
            days: 'Weekdays Only',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: '555-987-6543',
        },
        overviews: [
            'We are looking for a creative and experienced Landscape Architect to join our team at GreenScape Designs. In this role, you will be responsible for designing innovative outdoor spaces that combine aesthetics, functionality, and sustainability. If you have a passion for architecture and landscaping, we encourage you to apply.',
        ],
        responsibilities: [
            'Develop detailed landscape designs and plans that meet client specifications.',
            'Collaborate with clients, contractors, and project teams to ensure project success.',
            'Perform site analysis, including soil, climate, and environmental assessments.',
            'Incorporate sustainable practices and eco-friendly materials in designs.',
            'Oversee the installation process to ensure adherence to design specifications.',
        ],
        qualifications: [
            'Bachelor’s degree in Landscape Architecture or a related field.',
            'At least 3 years of professional experience in landscape design or architecture.',
            'Proficiency in design software such as AutoCAD, SketchUp, and Adobe Suite.',
            'Strong understanding of horticulture, sustainability, and site planning.',
            'Excellent communication and project management skills.',
        ],
    },
];

const benefits = [
    {
        id: 1,
        title: 'Career Growth',
        description: 'Explore abundant opportunities for career growth and advancement within the gardening and landscaping industry.',
        icon: <FaSeedling />  // Career Growth Icon
    },
    {
        id: 2,
        title: 'Training Programs',
        description: 'Participate in comprehensive training programs tailored to enhance your skills in gardening, landscaping, and horticulture, ensuring proficiency in various techniques and methods.',
        icon: <FaGraduationCap />  // Training Programs Icon
    },
    {
        id: 3,
        title: 'Competitive Pay',
        description: 'Enjoy attractive pay packages and benefits in the gardening and landscaping industry, ensuring financial stability and security.',
        icon: <FaMoneyBillAlt />  // Competitive Pay Icon
    },
    {
        id: 4,
        title: 'Flexible Hours',
        description: 'Benefit from flexible working hours designed to accommodate your personal commitments and lifestyle preferences, promoting work-life balance.',
        icon: <FaClock />  // Flexible Hours Icon
    },
    {
        id: 5,
        title: 'Team Collaboration',
        description: 'Experience a collaborative and supportive team environment within the gardening and landscaping industry, fostering camaraderie and mutual growth.',
        icon: <FaUsers />  // Team Collaboration Icon
    },
    {
        id: 6,
        title: 'Growth Potential',
        description: 'Unlock vast opportunities for personal and professional growth, with ample room for advancement and skill development in the dynamic gardening and landscaping industry.',
        icon: <FaArrowUp />  // Growth Potential Icon
    },
];


export { positions, benefits, careerIntro };